import { useProductDetailsModalContext } from '@app/components/products/ProductDetails/context/ProductDetailsModalContext';
import { Button } from '@app/components/various/Button';
import { ChevronLeft, ChevronRight } from '@app/components/various/Icons';
import { isDefined } from '@app/utils/is';
import { isEmpty } from 'ramda';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export const NavigationArrows = () => {
  const { t } = useTranslation(['products']);
  const { previousProductUrl, nextProductUrl, isLoadingMoreProducts, products } = useProductDetailsModalContext();

  return (
    <div className="flex gap-1">
      {!isEmpty(products) && (
        <>
          <Button
            as={Link}
            to={isDefined(previousProductUrl) ? previousProductUrl : '#'}
            color="secondary"
            variant="bordered"
            className="bg-white"
            disabled={!isDefined(previousProductUrl)}
            aria-label={t('products:previous_product')}
            icon={ChevronLeft}
          />
          <Button
            as={Link}
            to={isDefined(nextProductUrl) ? nextProductUrl : '#'}
            color="secondary"
            variant="bordered"
            className="bg-white"
            disabled={!isDefined(nextProductUrl)}
            isLoading={!isDefined(nextProductUrl) && isLoadingMoreProducts}
            aria-label={t('products:next_product')}
            icon={ChevronRight}
          />
        </>
      )}
    </div>
  );
};
